module.exports = __webpack_public_path__ + "static/media/img_2.a2752b1d.png";